import React, { useState } from 'react';
import { Flex, Stack, Text } from '@chakra-ui/layout';
import { HStack, Image, PinInput, PinInputField } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import logo from '~/assets/logo-service-gray.png';
import { ColorfulBar, Button } from '~/components';
import { ROUTER_PATHS } from '~/constants';

export const Authenticator: React.VFC = () => {
  const [pin, setPin] = useState<string>();

  function handleSubmit(event: React.SyntheticEvent) {
    event.preventDefault();
    console.log(pin);
  }

  return (
    <Flex w="100vw" h="100vh" flexDir="column">
      <ColorfulBar />
      <Flex justify="center" p="2" pt={16} h="100%">
        <Flex flexDir="column" align="center" maxW={300}>
          <Image src={logo} maxW="200px" mb="12" />
          <Flex flexDir="column">
            <Text textAlign="center">
              Informe o código de verificação enviado para o email
              ********@positivo.com.br
            </Text>
            <Stack
              as="form"
              w={300}
              gridGap="2"
              mt="8"
              onSubmit={e => handleSubmit(e)}
            >
              <Text
                textAlign="center"
                fontSize="14px"
                mb={-2}
                fontWeight="medium"
              >
                Código de Verificação
              </Text>
              <HStack justify="center">
                <PinInput onChange={value => setPin(value)}>
                  <PinInputField />
                  <PinInputField />
                  <PinInputField />
                  <PinInputField />
                </PinInput>
              </HStack>
              <Button disabled={pin?.length !== 4} type="submit">
                Verificar
              </Button>
              <Link to={ROUTER_PATHS.LOGIN}>
                <Text
                  fontSize="14px"
                  color="gray.900"
                  textAlign="center"
                  mt="4"
                >
                  Voltar
                </Text>
              </Link>
            </Stack>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
